module.exports = __webpack_public_path__ + "img/rightArrow.cd757df1.svg";